import {
    type GetBoardOfDirectorsResponseType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const GetBoardOfDirectors = async (): Promise<GetBoardOfDirectorsResponseType> => {
    return await axios(`${SERVER_ADDRESS}/front/getBoarOfDirectors`, {
        method: "GET",
        headers: getHeaders(true)
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default GetBoardOfDirectors;
